<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards :initSlideArr="mydata.initSlideArr" imgHeight="300px">
      <template #qwe>
        <div class="some-title">
          <p>授权网店</p>
          <p>感谢对天利38套的信任、喜爱和支持</p>
          <p>如您的网店想要代理天利38套图书，请点击</p>
          <el-button type="primary" @click="progressStep1Button"
            >申请授权</el-button
          >

          <p>填写代理信息后，耐心等待审核。</p>
          <el-button type="danger" @click="queryProgressStepButton"
            >查询进度</el-button
          >
        </div>
      </template>
    </imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 模块2————按钮 -->
    <div class="subject-button">
      <!-- 地域 -->
      <!-- <subjectButton
        :filterButton="mydata.filterButton1"
        style="margin-bottom: 20px"
        @change="change1"
      ></subjectButton> -->
      <!-- 类型 -->
      <subjectButton
        :filterButton="mydata.filterButton2"
        @change="change2"
        :key="mydata.testKey0"
      ></subjectButton>
    </div>
    <!-- 模块3————内容 -->
    <div class="box-content">
      <p class="content-head">全部（{{ mydata.pageObj.total }}）</p>

      <div class="content-main">
        <onlineShopCards
          :path="mydata.onlineShopCards_path"
          v-for="(item, index) in mydata.onlineStoreArr"
          :key="index"
          :info="item"
        ></onlineShopCards>

        <!-- 空白内容组件 -->
        <glEmpty
          v-if="mydata.onlineStoreArr.length === 0"
          marginBottom="20px"
        ></glEmpty>
        <!-- <onlineShopCards
          :path="mydata.path"
          v-for="(item, index) in mydata.storePlatformArr"
          :key="index"
          :info="item"
        ></onlineShopCards> -->
      </div>
    </div>
    <!-- 模块4————分页  -->
    <!--分页 -->
    <div class="gl-pagination" style="margin-top: 14px">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "authorizedOnlineShop",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/onlineShopDetails",
        "/layout/list/queryProgressStep",
        "/layout/list/progressStep",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>

  
  <script setup>
// import { Calendar } from "@element-plus/icons-vue";
// import { User } from "@element-plus/icons-vue";
// import { Document } from "@element-plus/icons-vue";

import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import subjectButton from "@/components/subjectButton/index.vue";
import onlineShopCards from "@/components/onlineShopCards/index.vue";

// 引入授权网店列表接口
import { onlineStoreList } from "@/api/distributionAuthorization/authorizedOnlineShop/index.js";

import { getUrlId } from "@/utils/slide";

import { reactive, onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();

const route = useRoute();

const mydata = reactive({
  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  initSlideArr: [
    {
      id: "默认值",
      image: require("@/assets/Rectangle 1131.png"),
    },
  ],

  //筛选按钮
  filterButton1: {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("searchList")).territory ?? [],
  },
  filterButton2: {
    title: "类型",
    filter: JSON.parse(localStorage.getItem("searchList")).platform ?? [],
  },
  testKey0: new Date().getTime() - Math.random() * 10,

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  onlineShopCards_path: "/layout/list/onlineShopDetails",

  onlineStoreArr: [], // 授权网店列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 20, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    territory: "", //地域
    platform: "", //类型
    // subject: "", //学科
  },
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.initSlideArr = [
      {
        id: "默认值",
        image: require("@/assets/Rectangle 1131.png"),
      },
    ];

    //筛选按钮
    mydata.filterButton1 = {
      title: "地区",
      filter: JSON.parse(localStorage.getItem("searchList")).territory ?? [],
    };
    mydata.filterButton2 = {
      title: "类型",
      filter: JSON.parse(localStorage.getItem("searchList")).platform ?? [],
    };
    mydata.testKey0 = new Date().getTime() - Math.random() * 10;

    // 基础地址
    mydata.VUE_APP_BASE_HOST = process.env.VUE_APP_BASE_HOST;
    mydata.onlineShopCards_path = "/layout/list/onlineShopDetails";

    mydata.onlineStoreArr = []; // 授权网店列表

    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 20, // 每页条数
      total: 0, // 总的条数
    };
    mydata.form = {
      // column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询
      territory: "", //地域
      platform: "", //类型
      // subject: "", //学科
    };
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    onlineStoreFn();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    // getSubject();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    onlineStoreFn();
    // getData()
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }
});

// console.log(mydata.filterButton2);

///////////////////////////////////
// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  onlineStoreFn();
}

// 授权网店列表
function onlineStoreFn() {
  onlineStoreList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 授权网店列表
    mydata.onlineStoreArr = res.data.list;
    // console.log(res.data.list,"授权网店列表")
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1;
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  onlineStoreFn();
}

// 地域单选改变事件
function change1(val) {
  // 赋值
  mydata.form.territory = val;
  // 查询
  onlineStoreFn();
}

// 类型单选框改变事件
function change2(val) {
  mydata.form.platform = val;
  // 查询
  onlineStoreFn();
}

// // 学科单选框改变事件
// function change3(val) {
//   mydata.form.subject = val;
//   // 查询
//   onlineStoreFn();
// }

// 查询
// onlineStoreFn();

///////////////////////////////////

//申请授权按钮点击事件
function progressStep1Button() {
  router.push({
    // path: "/layout/list/progressStep",
    path: "/layout/list/applicationProcess",
    // query: {
    //   step: 1,
    // },
  });
}

//查询进度按钮点击事件
function queryProgressStepButton() {
  router.push({
    path: "/layout/list/queryProgressStep",
  });
}

// //网店卡片点击事件
// function onlineShopDetailsButton() {
//   router.push({
//     path: "/layout/list/onlineShopDetails",
//   });
// }

// //店铺平台
// function storePlatformlist() {
//   //店铺平台列表
//   store_Platform({}).then((res) => {
//     console.log(res, "1222");
//     mydata.storePlatformArr = res.data
//   });
// }

// storePlatformlist();
</script>
  
<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  //图片上的字
  .some-title {
    width: 300px;
    position: absolute;
    top: 14%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: white;
    font-size: 8px;
    // border: 1px solid red;

    p {
      width: 320px;
      font-size: 10px;
      font-weight: 400;
      text-align: center;
      line-height: 13px;
      padding-right:50px;
      // white-space: nowrap; //不折行
      // text-overflow: ellipsis; //文本溢出 用省略号显示
      // overflow: hidden;
    }
    > p:nth-of-type(1) {
      font-size: 10px;
      // color:red;
      font-weight: 700;
      letter-spacing: 2px;

      // text-align: center;
      // margin-bottom: 9px;
    }
   
    ////申请授权按钮
    :deep(.el-button.el-button--primary) {
      width: 50px;
      height: 13px;
      line-height: 13px;
      border-radius: 30px;
      font-size: 8px;
      position: absolute;
      top: 21px;
      right: 5px;
      // margin:0 auto;
    }
    ////查询进度按钮
    :deep(.el-button.el-button--danger) {
      width: 50px;
      height: 13px;
      line-height: 13px;
      border-radius: 30px;
      font-size: 8px;
      position: absolute;
      top: 38px;
      right: 45px;
    }
  }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }

  ////////模块2————按钮
  .subject-button {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    overflow: hidden;
  }

  ///////模块3————内容
  .box-content {
    // width: 1200px;
    //height: 861px;
    margin: 0 auto;
    margin-top: 16px;
    // border: 1px solid blue;
    .content-head {
      // width: 1200px;
      height: 56px;
      background-color: #ffffff;
      // border: 1px solid blue;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
      padding-left: 17px;
    }
    .content-main {
      // padding: 30px 0;
      width: 343px;
      // height: 793px;
      // border: 1px solid rgb(9, 255, 0);
      border-radius: 8px;
      margin: 0 auto;
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      // align-content: space-between;
      flex-wrap: wrap;
      // overflow: hidden;
      //淘宝卡片组件
      :deep(.box-onlineShop) {
        // margin-right: 20px;
        margin-bottom: 10px;
      }
      //淘宝卡片组件
      :deep(.box-onlineShop):nth-of-type(4n) {
        margin-right: 0px;
      }
    }
  }

  // //////模块4————分页
  // .paging {
  //   // margin: 0 auto;
  //   margin-top: 40px;
  //   // margin-bottom: 40px;
  //   display: flex;
  //   justify-content: center;
  //   // border:1px solid red;

  //   :deep(.el-button.is-plain) {
  //     margin-left: 24px;
  //   }
  // }

  // .demo-pagination-block + .demo-pagination-block {
  //   margin-top: 10px;
  // }
  // .demo-pagination-block .demonstration {
  //   margin-bottom: 16px;
  // }
}
</style>
  